module.exports = __webpack_public_path__ + "img/modelo-pizzaria.7a013e1f.png";